export default __webpack_public_path__ + "static/media/CommonCityMap.6e0f7bb4.jpg";